export const flyoutCompanyDetailsFaq = [
  {
    question: 'Q1. Why does Labra need my company details?',
    answer:
      'These details are stored within Labra to personalize your workspace, organize listings, and give your team a consistent view of your company profile across the app.',
  },
  {
    question: 'Q2. Is this connected to Microsoft Partner Center?',
    answer:
      'No. The information here is for Labra’s internal use only. It does not affect your Microsoft Partner Center setup or verification.',
  },
  {
    question: 'Q3. Do I have to use my legal company name?',
    answer:
      'Not necessarily. You can use your brand name or any identifier your team will recognize. This will only be visible inside Labra.',
  },
  {
    question: 'Q4. Is a website required?',
    answer: 'Yes, entering a website is mandatory.',
  },
  {
    question: 'Q5. Which industry should I choose?',
    answer:
      'Industry selection is mainly for internal tagging and reporting inside Labra. If you don’t find an exact match, pick the closest one, it won’t affect your Microsoft onboarding.',
  },
  {
    question: 'Q6. Do I need to accept Labra’s Terms and Conditions?',
    answer:
      'Yes. Accepting Labra’s Terms and Conditions is mandatory to proceed with onboarding. This ensures you’re aligned with how Labra operates and provides its services.',
  },
  {
    question: 'Q7. Can I edit company details later?',
    answer:
      'Yes. All company details you add here are saved automatically and can be updated anytime under settings.',
  },
]
